export default __webpack_public_path__ + "static/media/image45.2268985a.png";